import React from 'react';
import { Col, Select } from 'antd';
import { I18n } from '@aws-amplify/core';

import { useRosaContext } from '../../../context';
import type { InputDefaultProps } from '../../../types';
import { FormItem } from '@/components/ui/Inputs/FormItem';
import { useListCompanies } from '@/hooks/v1/useListCompanies';

type CompanyDTO = {
	id: string;
	name: string;
};

export function Company({
	fieldName,
	fontSize = '1rem',
	disabled = false,
	isRequired = false
}: Readonly<InputDefaultProps>) {
	const { organization_id, company_id } = useRosaContext();

	const { data: companies } = useListCompanies({
		organization_id,
		company_id
	});

	const options = companies?.map((company: CompanyDTO) => {
		return {
			label: company?.name,
			value: company?.id
		};
	});

	return (
		<Col span={24}>
			<FormItem
				fontSize={fontSize}
				isRequired={isRequired}
				title={I18n.get('Industrial site')}
				namePath={[fieldName, 'company_id']}
			>
				<Select size="large" disabled={disabled} options={options} />
			</FormItem>
		</Col>
	);
}
